import React,{useState,useEffect,useRef,}from 'react'
import { Modal,message,Form,Input, Upload, Button,} from 'antd';
import { useGwGoodsGuigeUpdateQuery, useGwGoodsGuigeUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import { EditOutlined,UploadOutlined} from '@ant-design/icons';
import GetWebGoods from '../goods/GetWebGoods';
function WebGoodsSpecEdit(props) {
    const [form] = Form.useForm();           
    const [open, setOpen] = useState(false);
    const [info,setInfo] = useState({name:'',eowgg_sub_name:'',eowgg_sub_type_id:[]});
    
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        let arr = []
        for (let propName in values) {
            if(propName.includes('subType')){
                arr.push(values[propName])
            }     
        }
        
        submitUpdateSave({
            "eowgg_eowg_id" :info.eowgg_eowg_id,
            "eowgg_eowg_name" :info.eowgg_eowg_name,
            "eowgg_id" : props.eowgg_id,
            "eowgg_image" :info.eowgg_image,
            "eowgg_jiage" : info.eowgg_jiage,
            "eowgg_name" : info.eowgg_name,
            "eowgg_uid" : localStorage.getItem('eu_id'),
            "eowgg_uname" : localStorage.getItem('eu_name'),
        }).then((res) => {
            // console.log(res);
            if (res.data.Status === 'success') {
                message.success('修改成功！')   
                setOpen(false)                             
            }
            if (res.data.Status === 'fail') {
                message.error('修改失败！'+res.data.Message)
            }
        })
        setOpen(false);
    };   
    const editForm = useRef()
    const {data,isSuccess} = useGwGoodsGuigeUpdateQuery({eowgg_id:props.eowgg_id},{skip:!open})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                editForm.current.setFieldsValue({
                    eowgg_name:data.Result.eowgg_name,
                    eowgg_jiage:data.Result.eowgg_jiage,
                    eowgg_image:[data.Result.eowgg_image],
                    eowgg_eowg_id:data.Result.eowgg_eowg_id, 
                })
                setInfo(prevState=>({...prevState,
                    eowgg_name:data.Result.eowgg_name,
                    eowgg_jiage:data.Result.eowgg_jiage,
                    eowgg_image:data.Result.eowgg_image, 
                    eowgg_eowg_id:data.Result.eowgg_eowg_id, 
                    eowgg_eowg_name:data.Result.eowgg_eowg_name, 
                }))
                
            }
        }
    },[data,isSuccess])
    const [submitUpdateSave] = useGwGoodsGuigeUpdateSaveMutation()
    //上传图片
    const handleChange = (e) => {
        if (e.file.status === 'done'||e.file.status==='removed') {
            const fileArr = e.fileList.map((item) => {
                const { response } = item
                return response.Result
            })
            // console.log(e);
            let fileStr = fileArr + "";  
            if(fileStr === null){
                fileStr = ''
            }
            setInfo(prevState=>({...prevState,eowgg_image:fileStr,}))
        }
    }
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined/>  修改</a>
            <Modal
                open={open}
                title='修改商品规格'
                okText="提交"
                cancelText="取消"
                width={1200}
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_client_edit_${props.eowgg_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 2 }}
                    ref={editForm}
                >
                    <GetWebGoods
                        style={{width:"300px"}}
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,eowgg_eowg_id:e,eowgg_eowg_name:f}))
                        }}
                        label="商品"    
                        required      
                        name='eowgg_eowg_id'          
                    />
                    <Form.Item name="eowgg_name" label='规格名称' wrapperCol={{span:10}} required>
                        <Input onChange={(e) => {setInfo(prevState=>({...prevState,eowgg_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="eowgg_jiage" label='规格价格' wrapperCol={{span:10}}>
                        <Input
                            onChange={(e) => {setInfo(prevState=>({...prevState,eowgg_jiage:e.target.value}))}}
                        />                       
                    </Form.Item>
                    <Form.Item label="规格图片"                         
                        valuePropName='fileList'
                        getValueFromEvent={e => {
                            if (Array.isArray(e)) {
                                return e;
                            }
                            return e && e.fileList;
                        }}
                    >
                        <Upload
                            name="image_file"
                            action="/api/ReactApi/zd_single_upload_image"
                            listType="picture"
                            className="upload-list-inline"
                            onChange={handleChange}
                            >
                            <Button icon={<UploadOutlined />}>点击上传</Button>
                        </Upload>
                    </Form.Item>
                </Form>
            </Modal>
        </>
        
    )
}

export default WebGoodsSpecEdit